export const getErrors = errorResponse => {
  const errorData = errorResponse?.data?.errors;
  if (!errorData) return "An unknown error occurred";

  if (Array.isArray(errorData)) {
    return errorData[0]?.message || "An unknown error occurred";
  } else if (typeof errorData === "object") {
    return errorData.message || "An unknown error occurred";
  }
  return "An unknown error occurred";
};
export const validateEmail = email => {
  const regexEmail = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
  return regexEmail.test(email);
};
export const validatePassword = ({
  password,
  confirmPassword,
  minLength,
  strongPassword,
}) => {
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumber = /\d/.test(password);
  const hasSymbol = /[^\w\s]/.test(password);

  if (password !== confirmPassword) {
    return "Password and Confirm Password does not match";
  }
  if (password?.length < minLength) {
    return `Password must be at least ${minLength} characters long`;
  }
  if (
    strongPassword &&
    (!hasUpperCase || !hasLowerCase || !hasNumber || !hasSymbol)
  ) {
    return "Password must contain at least one uppercase letter, lowercase letter, number, and symbol.";
  }
  return null;
};

export default {
  getErrors,
  validateEmail,
  validatePasswordStrength: validatePassword,
};
